import { render, staticRenderFns } from "./CourseInfoVirtual.vue?vue&type=template&id=7055c850&"
import script from "./CourseInfoVirtual.vue?vue&type=script&lang=js&"
export * from "./CourseInfoVirtual.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfoVirtual.vue?vue&type=style&index=0&id=7055c850&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksColorBlock: require('/opt/build/repo/components/Blocks/ColorBlock.vue').default,TeflVirtualVideo: require('/opt/build/repo/components/TeflVirtualVideo.vue').default,CartBookButton: require('/opt/build/repo/components/Cart/BookButton.vue').default,CardsMoreInfoModal: require('/opt/build/repo/components/Cards/MoreInfoModal.vue').default})
